// CAPTCHA Configuration
export const CAPTCHA_CONFIG = {
  // Enable/disable CAPTCHA functionality
  enableCaptcha: true,
  
  // Google reCAPTCHA site key (public key)
  // IMPORTANT: 
  // - For localhost: Test key is used automatically (no setup needed)
  // - For production: Replace this with your actual reCAPTCHA v2 site key
  // - Get your key at: https://www.google.com/recaptcha/admin/create
  // - Make sure to select "reCAPTCHA v2" > "I'm not a robot" Checkbox
  // - Add your domain(s) in the reCAPTCHA admin panel
  siteKey: "6Ldmjw0sAAAAAEpGMpKM_a4UMY6KfovSd31g6bAz", // Replace with your production key
  
  // CAPTCHA display settings
  display: {
    showForLogin: true,          // Show CAPTCHA for login attempts
    showForFailedAttempts: true, // Show CAPTCHA after failed attempts
    theme: "light",              // "light" or "dark"
    size: "normal"               // "normal", "compact", or "invisible"
  },
  
  // Security settings
  security: {
    maxFailedAttempts: 3,        // Show CAPTCHA after this many failed attempts
    resetFailedAttemptsTime: 300000, // Reset failed attempts after 5 minutes (in ms)
    requireCaptchaAlways: false  // Always require CAPTCHA (if true, ignores maxFailedAttempts)
  },
  
  // Error messages
  messages: {
    captchaRequired: "Please complete the CAPTCHA verification",
    captchaExpired: "CAPTCHA has expired. Please try again",
    captchaError: "CAPTCHA verification failed. Please try again"
  }
};

// Helper function to check if CAPTCHA is enabled
export const isCaptchaEnabled = () => {
  return CAPTCHA_CONFIG.enableCaptcha;
};

// Helper function to check if CAPTCHA should be shown for login
export const shouldShowCaptchaForLogin = (failedAttempts = 0) => {
  if (!CAPTCHA_CONFIG.enableCaptcha) return false;
  
  if (CAPTCHA_CONFIG.security.requireCaptchaAlways) return true;
  if (CAPTCHA_CONFIG.display.showForLogin) return true;
  if (CAPTCHA_CONFIG.display.showForFailedAttempts && 
      failedAttempts >= CAPTCHA_CONFIG.security.maxFailedAttempts) return true;
  
  return false;
};

// Helper function to get CAPTCHA site key
export const getCaptchaSiteKey = () => {
  // Auto-detect environment and return appropriate key
  const isLocalhost = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || 
     window.location.hostname === '127.0.0.1' || 
     window.location.hostname === '');
  
  // Use test key for localhost, production key otherwise
  const testKey = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"; // Google's official test key
  
  return isLocalhost ? testKey : CAPTCHA_CONFIG.siteKey;
};

// Helper function to get CAPTCHA display settings
export const getCaptchaDisplaySettings = () => {
  return CAPTCHA_CONFIG.display;
};

// Helper function to get error messages
export const getCaptchaErrorMessage = (type = 'captchaRequired') => {
  return CAPTCHA_CONFIG.messages[type] || CAPTCHA_CONFIG.messages.captchaRequired;
};
